import { useEffect, useRef } from "react";
import "@/App.css";
import Lenis from "lenis";
import { BrowserRouter, Route, Routes, useLocation } from "react-router-dom";
import { Footer, Nav, WhatsFloat } from "@/components/shared";
import { LanguageProvider, useLang } from "@/i18n";
import Home from "@/pages/Home";
import Platform from "@/pages/Platform";
import Company from "@/pages/Company";

function Shell() {
  const location = useLocation();
  const { lang } = useLang();
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let frame;
    const loop = (time) => { lenis.raf(time); frame = requestAnimationFrame(loop); };
    frame = requestAnimationFrame(loop);
    return () => { cancelAnimationFrame(frame); lenis.destroy(); };
  }, []);

  useEffect(() => {
    const lenis = lenisRef.current;
    if (!lenis) return;
    if (location.hash) {
      const target = document.querySelector(location.hash);
      if (target) { const timer = setTimeout(() => lenis.scrollTo(target, { offset: -90 }), 90); return () => clearTimeout(timer); }
    }
    lenis.scrollTo(0, { immediate: true });
  }, [location]);

  return (
    <main className={`site-shell ${lang === "ur" ? "lang-ur" : ""}`} data-testid="asaancharge-page">
      <div className="grain" aria-hidden="true" />
      <Nav />
      <Routes location={location}>
        <Route path="/" element={<Home />} />
        <Route path="/platform" element={<Platform />} />
        <Route path="/company" element={<Company />} />
      </Routes>
      <Footer />
      <WhatsFloat />
    </main>
  );
}

export default function App() {
  return <BrowserRouter><LanguageProvider><Shell /></LanguageProvider></BrowserRouter>;
}
